import React, { useContext } from 'react';
import { ScrollLink } from 'src/components/scroll';
import { AppContext } from 'src/components/app-context';
import * as S from '../../styles';
import { blurActiveElement } from '../../utils';
import { IconChevronUp } from '@prisjakt/ui/icon/chevron-up';

const ProductScrollTopButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { t } = useContext(AppContext);
  return (
    <ScrollLink to="Top" onClick={blurActiveElement}>
      <S.BackToTopButton
        aria-label={t('product', 'back-to-top.button-description')}
      >
        <IconChevronUp />
      </S.BackToTopButton>
    </ScrollLink>
  );
};
export default ProductScrollTopButton;
